import { Injectable } from '@angular/core';
import { ApiService } from 'app/core/services/apiservice';
import { Usuario, Usuarios } from '../../../models/usuarios.model';
import { TipologiasInterface } from '../../../models/tipologias.model';
import { Tarea, TareasResponse } from '../../../models/tareas.model';
import { BehaviorSubject } from 'rxjs';
import { environment } from 'environments/environments';
import moment from 'moment';
import { TareasFilterParams } from './buzon-solicitudes/tareas-filter-params';

@Injectable({providedIn: 'root'})
export class SolicitudesService {
    usuarios: BehaviorSubject<Usuario[]> = new BehaviorSubject<Usuario[]>([])
    solicitudes: BehaviorSubject<TareasResponse> = new BehaviorSubject<TareasResponse>(null)
    public fechaActual= environment.TODAYS_DATE
    public fechaMes=`${moment().subtract(31, 'days').format('YYYY-MM-DD').toString()} 23:59`;
    tipologiaIdSolicitudes:number= environment.TIPOLOGIA_ID_SOLICITUDES
    tipologiaIdGestiones: number= environment.TIPOLOGIA_ID_GESTIONES
    params: Partial<TareasFilterParams> = {}

    constructor(
            private apiService: ApiService
        ) { }
    
    get usuarios$() {
        return this.usuarios.asObservable();
    }

    get solicitudes$() {
        return this.solicitudes.asObservable();
    }
    
    putUsuarioAsignado(usuarioAsignado: number, userKey: string) {
        const url = `/tareas/${userKey}`;
        const params = { usuarioAsignado };
    
        return new Promise((resolve, reject) => {
            this.apiService.PutMethod(url,null, params, 'Error al actualizar los datos.')
                .subscribe((response) => {
                    resolve(response)
                },error => {
                    reject(true)
                });
        });
    }
        

    getUsuarios(params?: any){
        const url='/users'
        return new Promise((resolve, reject)=>{
            this.apiService.GetMethod(url, params, 'Error al obtener los datos.')
                .subscribe((response: Usuarios) => {
                    this.usuarios.next(response.data);
                    resolve(response)                    
                }, error => {
                    reject(true)
                })
        })
    }

    getTipologiasFormularios(tipologia:number){
        const url=`/tipologias/${tipologia}`
        return new Promise((resolve, reject)=>{
            this.apiService.GetMethod(url, {}, 'Error al obtener los datos.')
                .subscribe((response: TipologiasInterface) => {
                    resolve(response)                    
                }, error => {
                    reject(true)
                })
        })
    }

    getTareasFiltro(_params:any){
        let params: any = { 
            tipoTarea: this.tipologiaIdSolicitudes, 
            fechaInicio: this.fechaMes, 
            fechaFin: this.fechaActual,
            ..._params
        };
        const url='/tareas'
        return new Promise((resolve, reject)=>{
            this.apiService.GetMethod(url, params, 'Error al obtener los datos.')
                .subscribe((response: TareasResponse) => {
                    this.solicitudes.next(response);
                    resolve(response)                
                }, error => {
                    reject(true)
                })
        })
    }

    getAllTasks(paramsTarea?: Partial<TareasFilterParams>) {  
        this.params.tipoTarea= this.tipologiaIdSolicitudes
        this.params.fechaFin= this.fechaActual
        this.params.fechaInicio= this.fechaMes

        if (paramsTarea) {
            if (paramsTarea.usuarioAsignado) {
                this.params.usuarioAsignado = paramsTarea.usuarioAsignado;
            }
    
            if (paramsTarea.clasificacion) {
                this.params.clasificacion = paramsTarea.clasificacion;
            }
    
            // Validamos si la sección es 0 o está definida
            if (paramsTarea.seccion !== undefined && paramsTarea.seccion !== null) {
                if (paramsTarea.seccion === 0) {
                    delete this.params.seccion;
                } else {
                    this.params.seccion = paramsTarea.seccion;
                }
            }
        }
    
        const url = '/tareas';
        return new Promise((resolve, reject) => {
            this.apiService.GetMethod(url, this.params, 'Error al obtener los datos.')
                .subscribe((response: TareasResponse) => {
                    this.solicitudes.next(response);
                    this.params = {};
                    resolve(response);                  
                }, error => {
                    reject(true);
                });
        });
    }
    
    
}